import React, { Fragment } from 'react'
import { Box } from '@mui/material';
import { RobotoTypo } from '../../../utils/Typographies';
import { useTranslation } from 'react-i18next';

export default function DormitoryInfo() {
    const { t } = useTranslation();
    return (
        <Box sx={{ padding: '4% 7%' }}>
            <RobotoTypo sx={{ fontWeight: '500', letterSpacing: '0.05em', color: '#003B5C', fontSize: { xs: '20px', sm: '25px', md: '28px', lg: '30px' }, textAlign: 'left' }}>
                {t('service.dormitory.info', { returnObjects: true }).title}
            </RobotoTypo><br />
            {t('service.dormitory.info.description', { returnObjects: true }).map((item, index) => (
                <Fragment key={index}>
                    <RobotoTypo sx={{ fontWeight: '400', letterSpacing: '0.03em', lineHeight: '25px', color: '#242424', fontSize: { xs: '15', md: '16px', lg: '16px', xl: '16px', }, textAlign: 'left' }}>
                        {item}
                    </RobotoTypo><br /></Fragment>
            ))}

        </Box>
    )
}
